import { useState } from "react";
import { XIcon } from "@phosphor-icons/react";

export default function TagInput({ value = [], onChange, placeholder = "Add tag…", testId = "tag-input" }) {
  const [draft, setDraft] = useState("");

  const add = () => {
    const t = draft.trim();
    if (!t) return;
    if (value.includes(t)) { setDraft(""); return; }
    onChange([...value, t]);
    setDraft("");
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div className="border border-[var(--border)] bg-white px-2 py-2 flex flex-wrap gap-1.5 focus-within:border-[var(--primary)]">
      {value.map((t, i) => (
        <span key={i} className="chip" data-testid={`${testId}-chip-${i}`}>
          {t}
          <button type="button" onClick={() => remove(i)} className="text-[var(--text-muted)] hover:text-[var(--danger)]" data-testid={`${testId}-remove-${i}`}>
            <XIcon size={11} weight="bold" />
          </button>
        </span>
      ))}
      <input
        type="text"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); }
          if (e.key === "Backspace" && !draft && value.length) remove(value.length - 1);
        }}
        onBlur={add}
        placeholder={placeholder}
        className="flex-1 min-w-[140px] outline-none text-sm font-mono text-[var(--text)] placeholder:text-[var(--text-muted)] bg-transparent"
        data-testid={`${testId}-input`}
      />
    </div>
  );
}
